import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "flex items-center w-full px-4 pt-3" }
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined" }, "close", -1)
const _hoisted_5 = { class: "px-4 pb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "draggableContainer",
    id: _ctx.containerId + '-draggable-container',
    style: _normalizeStyle(
			'box-shadow: 0 1px 3px 0 rgb(60 64 67 / 30%), 0 4px 8px 3px rgb(60 64 67 / 15%);top: ' +
			_ctx.initialTop +
			'px;left: ' +
			_ctx.initialLeft +
			'%;z-index: ' +
			(_ctx.inForeground ? '99999' : '200')
		),
    class: _normalizeClass(["fixed w-11/12 p-2 overflow-y-auto transition-opacity duration-75 card hover:opacity-100", {
			'opacity-80': !_ctx.opaque,
			'bg-light': !_ctx.whiteBg,
			'bg-white': _ctx.whiteBg,
			'md:w-2/5': !_ctx.large,
			'md:w-3/5': _ctx.large,
			resize: _ctx.resizable,
		}])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["absolute w-full cursor-move", [_ctx.dragOnTitleOnly ? 'h-18' : 'h-full']]),
      onMousedown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dragMouseDown && _ctx.dragMouseDown(...args)))
    }, null, 34),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createVNode(_component_Btn, {
        tooltip: _ctx.$t('misc.close'),
        variant: 'icon',
        outline: true,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
        class: "z-30 ml-auto"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["tooltip"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 14, _hoisted_1))
}